import './Flyout.scss';
import classNames from 'classnames';
import React, { ReactNode, useEffect } from 'react';
import modalCloseSvg from '../../assets/svgs/modal-close.svg';

export type FlyoutProps = {
  isOpen: boolean;
  title: string;
  children: ReactNode;
  onClose: () => void;
};

export const Flyout = ({ isOpen, title, children, onClose }: FlyoutProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <div className={classNames('p-flyout', { 'p-flyout-opened': isOpen })}>
      <div className="p-flyout__overlay" onClick={onClose} />
      <div className="p-flyout__wrapper">
        <div className="p-flyout__header">
          <div className="p-flyout__header__title h5">{title}</div>
          <button
            className="p-flyout__header__close"
            type="button"
            onClick={onClose}
            aria-label="Close Modal Button"
          >
            <img src={modalCloseSvg} />
          </button>
        </div>
        <div className="p-flyout__body">{children}</div>
      </div>
    </div>
  );
};
